import Dashboard from "../pages/Research/Dashboard";
import AnalystEngagement from "../pages/Research/AnalystEngagement";
import HistoricalReports from "../pages/Research/HistoricalReports";
import Performance from "../pages/Research/Performance";
import CorporateAccess from "../pages/Research/CorporateAccess";
import Publication from "../pages/Research/Publication";
import Error from "../pages/Error";
import InputSheets from "../pages/Admin/InputSheetManagement/InputSheets";
import UserDetails from "../pages/Admin/UserManagement/UserDetails";
import ClientDetails from "../pages/Admin/ClientManagement/ClientDetails";
import SectorDetails from "../pages/Admin/SectorManagement/SectorDetails";
import CategoryDetails from "../pages/Admin/CategoryManagement/CategoryDetails";
import SubCategoryDetails from "../pages/Admin/SubCategoryManagement/SubCategoryDetails";
import TierDetails from "../pages/Admin/TierManagement/TierDetails";
import RatingSpreadDetails from "../pages/Admin/RatingSpreadManagement/RatingSpreadDetails";
import AnalystAssignmentDetail from "../pages/Admin/AnalystAssignmentManagement/AnalystAssignmentDetail";
import Accounts from "../pages/Sales/Accounts";
import ToDoItems from "../pages/Sales/ToDoItems";
import { ClientPerformance } from "../pages/Sales/ClientPerformance";
import SalesDashboard from "../pages/Sales/SalesDashboard";

export const researchMenuItems = [
    {
        text: "Dashboard",
        icon: "/icons/dashboard.svg",
        path: "/research/dashboard",
    },
    {
        text: "Publications",
        icon: "/icons/publications.svg",
        path: "/research/publications",
    },
    {
        text: "Performance",
        icon: "/icons/performance.svg",
        path: "/research/performance",
    },
    {
        text: "Historical Reports",
        icon: "/icons/historical-reports.svg",
        path: "/research/history",
    },
];

export const salesMenuItems = [
    {
        text: "Sales Dashboard",
        icon: "/icons/table_chart_view.svg",
        path: "/sales/dashboard",
    },
    {
        text: "Accounts",
        icon: "/icons/user-management.svg",
        path: "/sales/accounts",
    },

    {
        text: "To Do Items",
        icon: "/icons/checklist.svg",
        path: "/sales/to-do-items",
    },
];

export const corporateMenuItems = [
    {
        text: "Corporate Access",
        icon: "/icons/corporate-access.svg",
        path: "/research/corporate-access",
    },
];

export const menuItems = (role) => {
    if (role === "admin" || role === "hybrid") {
        return {
            Research: [...researchMenuItems],
            Sales: [...salesMenuItems, ...corporateMenuItems],
        };
    } else if (role === "sales" || role === "head_of_sales") {
        return { Sales: [...salesMenuItems, ...corporateMenuItems] };
    } else if (role === "analyst" || role === "head_of_research") {
        return { Research: [...researchMenuItems, ...corporateMenuItems] };
    }
    return {};
};

export const adminMenuItems = [
    {
        text: "Input Sheet Upload",
        icon: "/icons/input-sheet.svg",
        path: "/admin/input-sheets",
    },
    {
        text: "User Management",
        icon: "/icons/user-management.svg",
        path: "/admin/user-details",
    },
    {
        text: "Client Management",
        icon: "/icons/client-management.svg",
        path: "/admin/client-details",
    },
    // { text: "Corporate Management", icon: "/icons/corporate-management.svg", path: "/admin/corporate-management" },
    {
        text: "Analyst Assignment",
        icon: "/icons/analyst-assignment.svg",
        path: "/admin/analyst-assignment",
    },
    {
        text: "Sector",
        icon: "/icons/sector.svg",
        path: "/admin/sectors",
    },
    {
        text: "Category",
        icon: "/icons/category.svg",
        path: "/admin/categories",
    },
    {
        text: "Sub Category",
        icon: "/icons/sub-category.svg",
        path: "/admin/sub-categories",
    },
    { text: "Tier", icon: "/icons/tier.svg", path: "/admin/tiers" },
    {
        text: "Rating Spread",
        icon: "/icons/rating-spread.svg",
        path: "/admin/rating-spreads",
    },

    // {
    //   text: "Config",
    //   icon: "/icons/config.svg",
    //   path: "/admin/configuration",
    // },
];

export const hiddenRoutes = [
    {
        path: "/analyst-engagement/:id",
        component: AnalystEngagement,
    },
    {
        path: "/client-performance/:id",
        component: ClientPerformance,
    },
    {
        path: "/error",
        component: Error,
    },
];

export const getRouteComponent = (path) => {
    try {
        const hiddenRoute = hiddenRoutes.find((route) => route.path === path);
        if (hiddenRoute) {
            return hiddenRoute.component;
        }
        switch (path) {
            case "/research/dashboard":
                return Dashboard;
            case "/research/history":
                return HistoricalReports;
            case "/research/publications":
                return Publication;
            case "/research/performance":
                return Performance;
            case "/research/corporate-access":
                return CorporateAccess;
            case "/sales/dashboard":
                return SalesDashboard;
            case "/sales/accounts":
                return Accounts;
            case "/sales/to-do-items":
                return ToDoItems;
            case "/admin/sector":
                return Dashboard;
            case "/admin/input-sheets":
                return InputSheets;
            case "/admin/user-details":
                return UserDetails;
            case "/admin/client-details":
                return ClientDetails;
            case "/admin/sectors":
                return SectorDetails;
            case "/admin/categories":
                return CategoryDetails;
            case "/admin/sub-categories":
                return SubCategoryDetails;
            case "/admin/tiers":
                return TierDetails;
            case "/admin/rating-spreads":
                return RatingSpreadDetails;
            case "/admin/analyst-assignment":
                return AnalystAssignmentDetail;
            default:
                return Error;
        }
    } catch (error) {
        console.error("Error in getRouteComponent:", error);
        return Error;
    }
};
